export interface DanceManagerNotificationMessagesCountInterface{
  danceManagerId?: string;
  notificationsCount?: number;
  messagesCount?: number;
}
